import { observer } from 'mobx-react';
import Button from '../../../../../../../../../Form/Button';
import LearningCollectionEditStore from '../../../../../../../Edit/Store';
import { SectionContext } from '../../../../../../../Types';
import Store from '../../../../Store';
import { ExperienceResource, ShowUnlicensedToggle } from '../../../../Types';
import { fromEmpty } from 'maybeasy';
import { toTask } from '@execonline-inc/maybe-adapter';

interface Props {
  store: Store;
  learningCollectionStore: LearningCollectionEditStore;
  context: SectionContext;
  resource: ExperienceResource;
  close: () => void;
  onOffWarning: ShowUnlicensedToggle;
}

const addProgramTask = (
  resource: ExperienceResource,
  store: Store,
  learningCollectionStore: LearningCollectionEditStore,
  context: SectionContext,
  onOffWarning: ShowUnlicensedToggle,
) => {
  toTask(
    'No scheduled program is available',
    fromEmpty(resource.payload.programInstanceOptions.scheduled),
  ).fork(
    () => {
      learningCollectionStore.addExperienceStore(context, resource);
      learningCollectionStore.saveShowWarning(onOffWarning);
    },
    () => {
      store.selectScheduledPrograms(resource);
      learningCollectionStore.saveShowWarning(onOffWarning);
    },
  );
};

const addProgram = ({
  close,
  resource,
  store,
  learningCollectionStore,
  context,
  onOffWarning,
}: Props) => {
  close();
  addProgramTask(resource, store, learningCollectionStore, context, onOffWarning);
};

function ConfirmationButton({
  store,
  context,
  learningCollectionStore,
  resource,
  close,
  onOffWarning,
}: Props) {
  return (
    <div>
      <Button
        onClick={() =>
          addProgram({
            store,
            learningCollectionStore,
            context,
            resource,
            close,
            onOffWarning,
          })
        }
        type="button"
        value="Proceed"
        className="px-5 py-2.5 bg-[#3A835D] rounded-md w-40 mt-6 text-[white]"
      />
      <Button
        onClick={close}
        type="button"
        value="Cancel"
        className="px-5 py-2.5 bg-white rounded-md w-40 ml-3 mt-6 text-teal-600"
      />
    </div>
  );
}

export default observer(ConfirmationButton);
